import { Navigate, useLocation, useSearchParams } from "react-router-dom";

export default function PrivateRoute({ element }) {
  const location = useLocation();
  let [searchParams] = useSearchParams();
  if(searchParams.has('token')){
    localStorage.setItem("tokenme", searchParams.get('token'));
    // searchParams.delete('token');
    // setSearchParams(searchParams, { replace: true });
  }
  
  return localStorage.getItem('tokenme') ? (
    element
  ) : (
    <Navigate to="/auth/login" state={{ from: location }} replace />
  );
}
